import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../../ricos-schema/next-schema/index.js";
const ORIGINAL_SHAPE_WIDTH = 200;
const DEFAULT_COLOR = "#000000";
const SEARCH_DEBOUNCE_MS = 350;
const DEFAULTS = {
  config: {
    alignment: "center",
    size: "CONTENT",
    textWrap: true
  }
};
const RICOS_DEFAULTS = {
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.ORIGINAL
    },
    textWrap: true
  }
};
const SHAPE_COLORS_MODAL_ID = `${Node_Type.SHAPE}.colors`;
const SHAPE_SIZE_MODAL_ID = `${Node_Type.SHAPE}.size`;
const SHAPE_ALIGNMENT_MODAL_ID = `${Node_Type.SHAPE}.alignment`;
const SHAPE_COLOR_PICKER_MODAL_ID = `${Node_Type.SHAPE}.colorPicker`;
const ALLOWED_SHAPE_ATTRIBUTES = [
  "data-bbox",
  "viewBox",
  "xmlns",
  "d",
  "fill",
  "opacity"
];
export {
  ALLOWED_SHAPE_ATTRIBUTES,
  DEFAULTS,
  DEFAULT_COLOR,
  ORIGINAL_SHAPE_WIDTH,
  RICOS_DEFAULTS,
  SEARCH_DEBOUNCE_MS,
  SHAPE_ALIGNMENT_MODAL_ID,
  SHAPE_COLORS_MODAL_ID,
  SHAPE_COLOR_PICKER_MODAL_ID,
  SHAPE_SIZE_MODAL_ID
};
//# sourceMappingURL=consts.js.map
